export const INITIAL_STATE = {
  uploadedFile: null,
  loading: false,
  error: null,
  result: null,
};

// Columns the backend requires in the sheet's header row (which can be
// anywhere in the first 10 rows). Spelling below - including "secrect_code" -
// must match the API exactly.
export const REQUIRED_COLUMNS = [
  'TM',
  'TM Contact Number',
  'Customer',
  'Customer Name',
  'Customer Contact Number',
  'Gift Allocation',
  'secrect_code',
  'unique_ref',
];

// Message codes returned by POST /v1.0/app/campaign-codes/upload.
// Some carry a dynamic suffix (a row number or a comma-separated list),
// appended after the colon/underscore shown here.
export const ERROR_CODES = {
  ACCESS_DENIED: 'ACCESS_DENIED',
  HEADER_ROW_NOT_FOUND: 'HEADER_ROW_NOT_FOUND',
  MISSING_REQUIRED_COLUMNS: 'MISSING_REQUIRED_COLUMNS',
  MISSING_SECRET_CODE_AT_ROW: 'MISSING_SECRET_CODE_AT_ROW_',
  DUPLICATE_SECRET_CODES_IN_FILE: 'DUPLICATE_SECRET_CODES_IN_FILE',
  NO_DATA_ROWS_FOUND: 'NO_DATA_ROWS_FOUND',
  UNREADABLE_EXCEL_FILE: 'UNREADABLE_EXCEL_FILE',
  SERVER_ERROR: 'SERVER_ERROR',
};

// User-facing copy for each error code, keyed so the main screen never has
// to hardcode backend message strings.
export const ERRORS = {
  [ERROR_CODES.ACCESS_DENIED]:
    "You don't have permission to upload the campaign codes sheet. This action requires the Thyaga Administrator role.",
  [ERROR_CODES.HEADER_ROW_NOT_FOUND]:
    'Could not find a header row with a secrect_code / secret_code column in the first 10 rows of the sheet.',
  [ERROR_CODES.MISSING_REQUIRED_COLUMNS]:
    'The header row was found, but the sheet is missing required column(s)',
  [ERROR_CODES.MISSING_SECRET_CODE_AT_ROW]:
    'Row is missing a secrect_code value',
  [ERROR_CODES.DUPLICATE_SECRET_CODES_IN_FILE]:
    'The same secret code appears more than once in the uploaded file',
  [ERROR_CODES.NO_DATA_ROWS_FOUND]:
    'A header row was found, but there are no data rows underneath it.',
  [ERROR_CODES.UNREADABLE_EXCEL_FILE]:
    "The file isn't a valid or readable .xlsx file. Please re-export it and try again.",
  [ERROR_CODES.SERVER_ERROR]:
    'Something went wrong on the server. Please try again.',
};

export const DEFAULT_UPLOAD_ERROR_MESSAGE =
  'Failed to upload the sheet. Please try again.';

// Resolves the raw `message` field from the API into a friendly, displayable
// string - handling both static codes and codes with a dynamic suffix.
export const getUploadErrorMessage = (rawMessage) => {
  if (!rawMessage) {
    return DEFAULT_UPLOAD_ERROR_MESSAGE;
  }

  if (ERRORS[rawMessage]) {
    return ERRORS[rawMessage];
  }

  if (rawMessage.startsWith(`${ERROR_CODES.MISSING_REQUIRED_COLUMNS}:`)) {
    const columns = rawMessage.split(':').slice(1).join(':').trim();
    return `${ERRORS[ERROR_CODES.MISSING_REQUIRED_COLUMNS]}: ${columns}`;
  }

  if (rawMessage.startsWith(ERROR_CODES.MISSING_SECRET_CODE_AT_ROW)) {
    const rowNumber = rawMessage.slice(
      ERROR_CODES.MISSING_SECRET_CODE_AT_ROW.length
    );
    return `${ERRORS[ERROR_CODES.MISSING_SECRET_CODE_AT_ROW]} ${rowNumber}.`;
  }

  if (
    rawMessage.startsWith(`${ERROR_CODES.DUPLICATE_SECRET_CODES_IN_FILE}:`)
  ) {
    const codes = rawMessage.split(':').slice(1).join(':').trim();
    return `${ERRORS[ERROR_CODES.DUPLICATE_SECRET_CODES_IN_FILE]}: ${codes}`;
  }

  return DEFAULT_UPLOAD_ERROR_MESSAGE;
};
